import styled from 'styled-components';

export const PreText = styled.pre`
  mark {
    background: ${(props) => props.theme.$keyword};
  }

  max-height: 400px;
  overflow: auto;
  word-break: normal;
  word-wrap: break-word;
  white-space: pre-wrap;
`;

export const Text = styled.div`
  mark {
    background: ${(props) => props.theme.$keyword};
  }
`;
